/*
 * Images rendered through snippets/deferred-image.liquid carry their srcset/src in data-defer-srcset /
 * data-defer-src. They are restored when the image comes within 600px of the viewport, with the theme's
 * fade-in (img.lazy → opacity 0, base.css). Hidden images (display: none) never intersect, so they are
 * never fetched. Loaded by sections/trace-product.liquid and sections/comfort-cashmere.liquid.
 */
(function () {
  if (window.deferredImages) return;

  function show(img) {
    const srcset = img.getAttribute('data-defer-srcset');
    const src = img.getAttribute('data-defer-src');
    if (!src && !srcset) return;
    img.classList.add('lazy');
    const done = () => img.classList.remove('lazy');
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    img.removeAttribute('data-defer-srcset');
    img.removeAttribute('data-defer-src');
  }

  // A slide scrolled out sideways in a swiper never intersects (the swiper clips it), so when one image of a
  // swiper comes near, its rendered siblings load too; display: none copies stay unloaded.
  function showWithSiblings(img) {
    const swiper = img.closest('swiper-component, .swiper');
    const imgs = swiper ? swiper.querySelectorAll('img[data-defer-src]') : [img];
    imgs.forEach(other => {
      if (other !== img && !other.getClientRects().length) return;
      if (observer) observer.unobserve(other);
      show(other);
    });
  }

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) showWithSiblings(entry.target);
            });
          },
          { rootMargin: '600px 0px' }
        )
      : null;

  function scan(root) {
    (root || document).querySelectorAll('img[data-defer-src]').forEach(img => {
      if (observer) observer.observe(img);
      else show(img);
    });
  }

  window.deferredImages = { scan };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }
  // Theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
